
// jQueryを使わずにES6に書き換えて
// $('.js-toggleTrigger').on('click', function() {
//   $(this).toggleClass('is-active');
//   $(this).siblings('.js-toggleTarget').slideToggle();
// })
const toggleTrigger = document.querySelectorAll('.js-toggleTrigger');

function toggleTarget() {
  const target = this.nextElementSibling;
  if (target.classList.contains('js-toggleTarget')) {
    target.classList.toggle('is-active');
  }
}

function toggleActive() {
  this.classList.toggle('is-active');
  this.parentNode.classList.toggle('is-open');
}

function handleToggleClick() {
  toggleActive.call(this);
  toggleTarget.call(this);
}

toggleTrigger.forEach((trigger) => {
  const target = trigger.nextElementSibling;
  if (target.classList.contains('js-toggleTarget')) {
    target.classList.add('is-hidden');
  }
  trigger.addEventListener('click', handleToggleClick);
});

const headerNav = 100;
const links = document.querySelectorAll('a[href^="#"]');

links.forEach(link => {
  link.addEventListener('click', e => {
    e.preventDefault();

    const href = link.getAttribute('href');
    const target = document.querySelector(href === '#' || href === '' ? 'html' : href);
    const position = target.offsetTop - headerNav;
    window.scrollTo({
      top: position,
      behavior: 'smooth'
    });
  });
});